import axios from "axios";
import queryString from "query-string";

const AbTestServices = {
  get: async (data) => {
    const params = queryString.stringify(data);
    const response = await axios.get(
      process.env.REACT_APP_API_URL + `/eira/abtest?${params}`
    );
    return response;
  },
  delete: async (data) => {
    const response = await axios.delete(
      process.env.REACT_APP_API_URL + `/eira/abtest`,
      {
        abtest_id: data.abtest_id,
      }
    );
    return response;
  },
  edit: async (data) => {
    const response = await axios.put(
      process.env.REACT_APP_API_URL + `/eira/abtest`,
      {
        abtest_id: data.abtest_id,
        name: data.name,
        type: data.type,
        start_date: data.start_date,
        end_date: data.end_date,
      }
    );
    return response;
  },
  add: async (data) => {
    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/eira/abtest`,
      {
        name: data.name,
        type: data.type,
        start_date: data.start_date,
        end_date: data.end_date,
      }
    );
    return response;
  },
  addManager: async (data) => {
    const formData = new FormData();
    formData.append("file_name", data.file_name);
    formData.append("group_type", data.group_type);
    formData.append("ABTest_id", data.abtest_id);
    formData.append("file", data.file);

    const response = await axios.post(
      process.env.REACT_APP_API_URL + `/eira/abtest-manager`,
      formData,
      {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }
    );
    return response;
  },
  uploadFile: async (file, abtestId, groupType) => {
    try {
      const response = await AbTestServices.addManager({
        file_name: file.name,
        group_type: groupType,
        abtest_id: abtestId,
        file: file,
      });

      return response;
    } catch (error) {
      console.error("Error uploading file:", error);
      throw error;
    }
  },
};

export default AbTestServices;
